import Button from "@ergeon/core-components/exports/Button.ts";

import { CheckIcon, ExclamationTriangleIcon } from "@ergeon/icons/hero/micro";

interface PermissionChipProps {
  name: string;
  granted: boolean;
  onEnable(): void;
}

/**
 * One permission in the lobby's readiness row. Both states are the same button
 * so the row keeps one rhythm: tapping re-asks for the permission, which fixes
 * a missing one and re-checks a granted one against the browser's own site
 * controls, where the customer may have just revoked it.
 */
export default function PermissionChip({ name, granted, onEnable }: PermissionChipProps) {
  const Icon = granted ? CheckIcon : ExclamationTriangleIcon;

  return (
    <li className="flex">
      <Button
        ariaLabel={granted ? `${name} is on` : `${name} is off — enable it`}
        className="gap-2"
        flavor={granted ? "success" : "warning"}
        onClick={onEnable}
        shape="circle"
        size="medium"
        taste={granted ? "line" : "solid"}>
        <Icon className="size-4 shrink-0" />
        {granted ? name : `Enable ${name}`}
      </Button>
    </li>
  );
}
